import React from "react";
import Tabs from "../../../../componentsUI/estructura/tabs/Tabs.js";

import CrearAjusteInventarioForm from "../inventarios/crearMovimientoEntrada.js";
import ControlPeriodoInventario from "./configurarPeriodo.js";

export default function ParametrosInventario() {
  const configuracionModuloTabs = [
    {
      id: "periodos",
      label: "Cambiar Periodos",
      content: <ControlPeriodoInventario />,
    },
    {
      id: "ajustes",
      label: "Crear ajustes",
      content: <CrearAjusteInventarioForm />,
    },
  ];
  return <Tabs tabs={configuracionModuloTabs} defaultTabId="producto_linea" />;
}
